import { theme } from './theme';

/**
 * Helpers de media query para uso dentro de styled-components.
 *
 * @example
 * ```ts
 * const Hero = styled.section`
 *   padding: ${theme.spacing[8]};
 *
 *   ${media.tablet} {
 *     padding: ${theme.spacing[16]};
 *   }
 * `;
 * ```
 */
export const media = {
  /** ≥ 480px */
  mobile: `@media (min-width: ${theme.breakpoints.mobile}px)`,
  /** ≥ 768px */
  tablet: `@media (min-width: ${theme.breakpoints.tablet}px)`,
  /** ≥ 1024px */
  laptop: `@media (min-width: ${theme.breakpoints.laptop}px)`,
  /** ≥ 1280px */
  desktop: `@media (min-width: ${theme.breakpoints.desktop}px)`,
  /** ≥ 1536px */
  wide: `@media (min-width: ${theme.breakpoints.wide}px)`,

  /** Versões "max-width" — uso pontual. */
  mobileOnly: `@media (max-width: ${theme.breakpoints.tablet - 1}px)`,
  tabletDown: `@media (max-width: ${theme.breakpoints.laptop - 1}px)`,

  /** Preferências do usuário. */
  reducedMotion: '@media (prefers-reduced-motion: reduce)',
  dark: '@media (prefers-color-scheme: dark)',
  hover: '@media (hover: hover) and (pointer: fine)',
  touch: '@media (hover: none) and (pointer: coarse)',
} as const;
